/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
/**
 * Name of the primary outlet.
 * @type {string}
 *
 * @experimental
 */
exports.PRIMARY_OUTLET = 'PRIMARY_OUTLET';
//# sourceMappingURL=shared.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/router/src/shared.js
// module id = 363
// module chunks = 2